import { QueryClient } from '@tanstack/react-query';
import type { UndefinedInitialDataOptions } from '@tanstack/react-query/src/queryOptions';
import { AxiosError } from 'axios';
import type { UseQueryResult } from '@tanstack/react-query/src/types';
import { toast } from 'react-toastify';
import { ToastMessage } from '@app/utilities';
import { useGlobalContext } from '../GlobalContextProvider';
import { useQueryWithAuth } from './UseAuthQuery';

export function useQueryWithErrorHandling<TQueryFnData = unknown, TData = TQueryFnData>(
  {
    queryKey,
    ...options
  }: UndefinedInitialDataOptions<TQueryFnData, AxiosError, TData, any[]> & { silent404?: boolean },
  queryClient?: QueryClient
): UseQueryResult<TData, AxiosError> {
  const { tenantId } = useGlobalContext();
  const opts = {
    queryKey: [...queryKey, tenantId],
    ...options,
    retry: (failureCount, error) => {
      console.log(`Failure count: ${failureCount}`);
      console.log(`Error: ${error}`);
      console.dir(error);

      if ((failureCount === 3 && error.response.status !== 404) || error.response.status === 500) {
        const { type, status, detail, ...problemDetails }: any = error.response.data || {};

        toast(
          <ToastMessage message={detail ?? error.message} errorData={problemDetails ?? error.response.data.errors} />
        );

        return false;
      }

      if (error.response.status === 404) {
        if (options.silent404 !== true) {
          const { type, status, detail, ...problemDetails }: any = error.response.data || {};

          toast(
            <ToastMessage message={detail ?? error.message} errorData={problemDetails ?? error.response.data.errors} />
          );
        }

        return false;
      }

      return true;
    },
  };
  return useQueryWithAuth(opts, queryClient);
}
